import axios from "axios"
import store from "../../../../../Redux/store"
import { setBillLoading, setDialogBox, setErrorSnack, setKOTManualDialog, setKOTSingleInfo, setOrderIdInPOS, setSingleOrderInfo, setSnackMsg, setSuccessSnack } from "../Slice/billingScreenSlice"
import { HEADERS } from "../../../../../API/UrlAndPaths"
import { setAggregator, setAggregatorRef, setBtnSelected, setOngoingOrderCount, setSingleCusInfo } from "../Components/topBarSliceBilling"
import { setCartLoading } from "../Slice/viewOrdersBillingSlice"
import { setAuthPassword } from "../newBillingSlice"
import { deliveryReceiptInfo } from "./billingPaymentSection"
import { errorSnackMsg } from "../../../../Custom Hooks/SnackkBarUtilities"
import { setPosReceiptSlice } from "../../../Settings/posReceipt/posReceiptSlice"



export const addPOSOrdertoKOT = async (body, clearFn, orderType, printReceipt) => {
    store.dispatch(setBillLoading(true));

    const printSettingsString = localStorage.getItem('PrinterSettings');
    const printSettings = JSON.parse(printSettingsString);

    try {
        const response = await axios.post("pos/postOrderFromFloorPlan", body, HEADERS);
        
        // Handle both online (200) and offline (202) responses
        if (response.status === 200 || response.status === 202) {
            const isOffline = response.status === 202;
            const data = response.data;
            const kotData = data.kotData;
            const orderId = data?.data?._id;

            console.log(`📦 Order created ${isOffline ? 'OFFLINE' : 'online'}: ${orderId}`);

            store.dispatch(setOngoingOrderCount(data.onGoing || 0));
            store.dispatch(setSnackMsg(isOffline ? "Order Placed Offline" : "Order Placed Successfully"));
            store.dispatch(setSuccessSnack(true));
            store.dispatch(setAggregator(null));
            store.dispatch(setAggregatorRef(null));

            // Always handle KOT printing first (for both payment and non-payment orders)
            console.log('🎫 Checking KOT data:', kotData ? 'FOUND' : 'NOT FOUND');
            console.log('🎫 kotAuto setting:', printSettings?.kotAuto);
            console.log('🎫 printReceipt function:', typeof printReceipt === 'function' ? 'AVAILABLE' : 'NOT AVAILABLE');
            
            if (kotData) {
                console.log('🎫 KOT data available:', JSON.stringify(kotData));
                store.dispatch(setKOTSingleInfo(kotData));
                
                if (printSettings?.kotAuto && typeof printReceipt === 'function') {
                    console.log('🖨️ Auto-printing KOT...');
                    printReceipt(kotData);
                } else if (!printSettings?.kotAuto) {
                    console.log('📋 Opening manual KOT print dialog');
                    store.dispatch(setKOTManualDialog("kotPrint"));
                } else {
                    console.log('⚠️ kotAuto enabled but printReceipt function not available');
                    store.dispatch(setKOTManualDialog("kotPrint"));
                }
            } else {
                console.log('⚠️ No KOT data in response');
                store.dispatch(setKOTSingleInfo(null));
            }

            if (orderType === "paymentOrder") {
                store.dispatch(setBtnSelected("payment"));
                // Set order ID in Redux BEFORE calling singlePOSOrderInfoAPICall
                store.dispatch(setOrderIdInPOS(orderId));
                console.log(`💳 Direct payment mode - loading order: ${orderId}`);
                singlePOSOrderInfoAPICall({ id: orderId });
            } else {
                store.dispatch(setDialogBox(false));
                store.dispatch(setOrderIdInPOS(null));
            }

            // Call delivery receipt info if order type is DELIVERY and not switching straight to payment flow
            if (body.ordType === "DELIVERY" && orderType !== "paymentOrder") {
                deliveryReceiptInfo({ orderId });
            }

            // Clear the form after successful order placement
            clearFn();
        }
    } catch (error) {
        const errorMessage = error.response?.status === 500 
            ? "Internal Server Error !!" 
            : error.response?.status === 400 
                ? error.response.data[0]?.msg 
                : error.response?.data || "An error occurred";

        store.dispatch(setSnackMsg(errorMessage));
        store.dispatch(setErrorSnack(true));
    } finally {
        store.dispatch(setBillLoading(false));
    }
};

// add order from pos
// export const addPOSOrdertoKOT=async(body,clearFn,orderType,printReceipt)=>{

//     store.dispatch(setBillLoading(true))
//     const printSettingsString=localStorage.getItem('PrinterSettings')
//     const printSettings=JSON.parse(printSettingsString)
//     await axios.post("pos/postOrderFromFloorPlan",body,HEADERS)
//         .then((res)=>{
//             if(res.status===200){
//                 store.dispatch(setOngoingOrderCount(res?.data?.onGoing || 0))
//                 store.dispatch(setBillLoading(false))                  

//                 store.dispatch(setSnackMsg("Order Placed Successfully"))
//                 store.dispatch(setSuccessSnack(true))
//                 store.dispatch(setAggregator(null))
//                 store.dispatch(setAggregatorRef(null))
        
//                 if(orderType==="paymentOrder"){  
//                     store.dispatch(setBtnSelected("payment"))
//                     singlePOSOrderInfoAPICall({id:res?.data?.data?._id})   
//                 }
//                 else{
//                     store.dispatch(setOrderIdInPOS(null))

//                     if(res?.data?.kotData===null){
//                         store.dispatch(setDialogBox(false))        
//                     }else{
//                         store.dispatch(setDialogBox(false))        
//                         (printSettings?.kotAuto)?printReceipt(res?.data?.kotData) : store.dispatch(setKOTManualDialog("kotPrint"))           
//                     }    
//                     store.dispatch(setKOTSingleInfo(res?.data?.kotData || null))
//                 }
//                 clearFn()
//                 body.ordType==="DELIVERY" && deliveryReceiptInfo({orderId:res?.data?.data?._id})

//             }
//         })
//         .catch((err)=>{
//             // let message=err.response.status===500?"Internal Server Error !!":err.response.status===400?err.response.data[0]?.msg:err.response.data
//                 store.dispatch(setSnackMsg("message"))
//                 store.dispatch(setBillLoading(false))                
//                 store.dispatch(setErrorSnack(true))
//         })
// }

// add pos order without chair selected
export const addPOSOrderWoFloorSelectionAPI=async(body,clearFn,orderType,printReceipt)=>{
    console.log("addPOSOrderWoFloorSelectionAPI called with body:", body);
    console.log("🎫 printReceipt function passed:", typeof printReceipt === 'function' ? 'YES' : 'NO');
    const printSettingsString=localStorage.getItem('PrinterSettings')
    const printSettings=JSON.parse(printSettingsString)
    store.dispatch(setBillLoading(true))
    await axios.post("pos/addPosOrder",body,HEADERS)
        .then((res)=>{
            console.log('📥 addPosOrder response:', res.status, res.data);
            console.log('📥 Full response object:', res);
            if(res.status===200 || res.status===202){
                // Handle both online (200) and offline queued (202) the same way
                const isOffline = res.status === 202;
                const responseData = res.data;
                console.log('📥 isOffline:', isOffline);
                console.log('📥 responseData:', responseData);
                console.log('📥 responseData.data:', responseData?.data);
                
                store.dispatch(setOngoingOrderCount(responseData?.onGoing || 0))
                store.dispatch(setBillLoading(false))                
                store.dispatch(setSnackMsg(isOffline ? "Order placed (offline - will sync)" : "Order Placed Successfully"))
                store.dispatch(setSuccessSnack(true))
                
                console.log(`🔍 orderType is: "${orderType}"`);
                
                // Handle KOT printing (skip for direct payment orders)
                console.log('🎫 Checking KOT data:', responseData?.kotData ? 'FOUND' : 'NOT FOUND');
                console.log('🎫 kotAuto setting:', printSettings?.kotAuto);
                console.log('🎫 printReceipt function:', typeof printReceipt === 'function' ? 'AVAILABLE' : 'NOT AVAILABLE');
                console.log('🎫 orderType:', orderType);
                
                if(responseData?.kotData){
                    console.log('🎫 KOT data available:', JSON.stringify(responseData.kotData));
                    store.dispatch(setKOTSingleInfo(responseData.kotData));
                    
                    // Skip KOT dialog for direct payment orders - user is going straight to payment screen
                    if(orderType === "paymentOrder"){
                        console.log('⏭️ Skipping KOT dialog for direct payment order');
                    } else if(printSettings?.kotAuto && typeof printReceipt === 'function'){
                        console.log('🖨️ Auto-printing KOT...');
                        printReceipt(responseData.kotData);
                    } else if(!printSettings?.kotAuto) {
                        console.log('📋 Opening manual KOT print dialog');
                        store.dispatch(setKOTManualDialog("kotPrint"));
                    } else {
                        console.log('⚠️ kotAuto enabled but printReceipt function not available');
                        store.dispatch(setKOTManualDialog("kotPrint"));
                    }
                } else {
                    console.log('⚠️ No KOT data in response');
                    store.dispatch(setKOTSingleInfo(null));
                }
                
                if(orderType==="paymentOrder"){
                    // Always use the order id returned in response data for both online and offline
                    const orderId = responseData?.data?._id;
                    console.log(`🎯 Direct payment: Setting orderIdInPOS to: ${orderId}`);
                    console.log(`🎯 About to load order details for: ${orderId}`);
                    store.dispatch(setOrderIdInPOS(orderId));
                    // Load the order details before switching to payment
                    singlePOSOrderInfoAPICall({ id: orderId });
                    store.dispatch(setBtnSelected("payment"));
                } else {
                    store.dispatch(setDialogBox(null));
                    store.dispatch(setOrderIdInPOS(null));
                }
                clearFn()
                store.dispatch(setAggregator(null))
                store.dispatch(setAggregatorRef(null))
                
                // Skip delivery receipt in offline mode or when redirecting to payment flow immediately
                if(!isOffline && body.ordType==="DELIVERY" && orderType !== "paymentOrder"){
                    deliveryReceiptInfo({orderId:responseData?.data?._id})
                }
            }
        })
        .catch((err)=>{
            console.error('❌ addPosOrder error:', err.response?.status, err.response?.data);
            // Show actual error message from backend instead of generic messages
            let message;
            const data = err.response?.data;
            if (Array.isArray(data?.data)) {
                // Validation errors array
                message = data.data.map(e => e.msg || e.message).join(', ') || 'Validation failed';
            } else {
                message = data?.message || (typeof data === 'string' ? data : null) || 
                    (err.response?.status === 500 ? "Internal Server Error !!" : "Network Error");
            }
            errorSnackMsg(message)
            store.dispatch(setBillLoading(false))
        })
}
export const quickBillOrderAPI=async(body,clearFn)=>{
    store.dispatch(setBillLoading(true))
    await axios.post("pos/addQuickBill",body,HEADERS)
        .then((res)=>{
            if(res.status===200 || res.status===202){  // Accept both 200 (online) and 202 (offline)
                const currentOrderId = store.getState().billingScreenSlice.orderIdForPos
                currentOrderId===res.data?.data?._id?singlePOSOrderInfoAPICall({ id: currentOrderId }) :store.dispatch(setOrderIdInPOS(res.data?.data?._id))

                store.dispatch(setBillLoading(false))  
                store.dispatch(setAggregator(null))
                store.dispatch(setAggregatorRef(null))
                clearFn()
            }
        })
        .catch((err)=>{
            let message=err.response.status===500?"Internal Server Error !!":err.response.status===400?"Delivery partner not selected!!":err.response.data
                errorSnackMsg(message)
                store.dispatch(setBillLoading(false))  
        })
}
// update an existing order

export const updatePosOrderAPICall = async (body, clearFn, orderType, printReceipt) => {
    try {
        store.dispatch(setBillLoading(true));

        // Retrieve and parse printer settings
        const printSettingsString = localStorage.getItem('PrinterSettings');
        const printSettings = JSON.parse(printSettingsString);

        // Make the API request to update the order
        const response = await axios.post('pos/addItemsToExistingOrders', body, HEADERS);

        const { status, data } = response;
        // Handle both online (200) and offline (202) responses
        if (status === 200 || status === 202) {
            const isOffline = status === 202;
            const orderId = data?.data?._id;
            const kotData = data?.kotData;
            store.dispatch(setOngoingOrderCount(data?.onGoing || 0))

            // Resetting order and UI states
            store.dispatch(setOrderIdInPOS(null));
            store.dispatch(setSnackMsg(isOffline ? 'Order Updated (offline - will sync)' : 'Order Updated 👍'));
            store.dispatch(setSuccessSnack(true));
            store.dispatch(setBillLoading(false));

            // Handling different order types
            if (orderType === 'paymentOrder') {
                store.dispatch(setBtnSelected('payment'));
                // Ensure the new orderId is set after updating
                setTimeout(() => {
                    store.dispatch(setOrderIdInPOS(orderId));
                }, 0);
            } else {
                // Handle KOT (Kitchen Order Tickets) and dialog state
                if (!kotData) {
                    store.dispatch(setDialogBox(null));
                } else {
                    store.dispatch(setDialogBox(null));
                    if (printSettings?.kotAuto) {
                        printReceipt(kotData); // Automatically print if setting is enabled
                    } else {
                        store.dispatch(setKOTManualDialog('kotPrint')); // Open manual print dialog
                    }
                }
                store.dispatch(setKOTSingleInfo(kotData || null));
            }

            // Reset aggregator and authentication-related states
            store.dispatch(setAggregator(null));
            store.dispatch(setAggregatorRef(null));
            store.dispatch(setAuthPassword(''));
            store.dispatch(setDialogBox(null));

            // Clear any temporary form data and handle delivery-specific receipts
            clearFn();
            if (body.ordType === 'DELIVERY') {
                deliveryReceiptInfo({ orderId });
            }
        }
    } catch (error) {
        // Handle API errors gracefully
        const message =
            error?.response?.status === 500
                ? 'Internal Server Error !!'
                : error?.response?.data || 'Error occurred during order update';

        // Set error state
        store.dispatch(setSnackMsg(message));
        store.dispatch(setBillLoading(false));
        store.dispatch(setErrorSnack(true));
    }
};

// get single order info

export const singlePOSOrderInfoAPICall=async(body)=>{
    console.log(`📞 singlePOSOrderInfoAPICall called with id: ${body?.id}`);
    store.dispatch(setCartLoading(true))
    store.dispatch(setBillLoading(true))
    await axios.post("pos/viewPosOrderById",body,HEADERS)
    .then((res)=>{
        // Handle both online (200) and offline (202) responses
        if(res.status===200 || res.status===202){
                console.log(`✅ Loaded order: ${res.data?._id} (status ${res.status})`);
                store.dispatch(setBillLoading(false))
                // Use order data as-is from backend - delivery charge already correct
                store.dispatch(setSingleOrderInfo(res.data))
                
                // Ensure POS receipt template is loaded with localStorage priority
                const localTemplate = localStorage.getItem('posReceiptTemplate');
                console.log('🔍 singlePOSOrderInfoAPICall: localStorage posReceiptTemplate =', localTemplate);
                if (localTemplate) {
                    console.log('🎯 singlePOSOrderInfoAPICall: Using localStorage template as priority:', localTemplate);
                    store.dispatch(setPosReceiptSlice({ posReceiptTemplate: Number(localTemplate) }));
                } else {
                    console.log('⚠️ singlePOSOrderInfoAPICall: No template found in localStorage');
                }
                
                store.dispatch(setCartLoading(false))
            }
        })
        .catch((err)=>{
            console.error(`❌ Failed to load order: ${body?.id}`, err);
            store.dispatch(setBillLoading(false))
            store.dispatch(setSingleOrderInfo(null))
                store.dispatch(setCartLoading(false))
        })
}


// hold order
export const holdPOSOrderAPI=async(body,clearFn)=>{
    store.dispatch(setBillLoading(true))
    await axios.post("pos/addPosOrderHold",body,HEADERS)
        .then((res)=>{
            if(res.status===200 || res.status===202){
                const isOffline = res.status === 202;
                store.dispatch(setOngoingOrderCount(res?.data?.onGoing || 0))
                store.dispatch(setBillLoading(false))                
                store.dispatch(setDialogBox(false))                
                store.dispatch(setSnackMsg(isOffline ? "Order held (offline - will sync)" : "Order Holded"))
                store.dispatch(setSuccessSnack(true))
                clearFn()
                store.dispatch(setAggregator(null))
                store.dispatch(setAggregatorRef(null))
            }
        })
        .catch((err)=>{
            let message=err.response?.status===500?"Internal Server Error !!":err.response?.status===400?"Wrong data passed!!":err.response?.data||"Network Error"
                store.dispatch(setSnackMsg(message))
                store.dispatch(setBillLoading(false))                
                store.dispatch(setErrorSnack(true))
        })
}

// get customer single info

export const getSingleCustomerInfoAPICall=async(body)=>{
    await axios.post("customer/getSingleVendorDetails",body,HEADERS)
        .then((res)=>{
            if(res.status===200){
                store.dispatch(setSingleCusInfo(res.data))
            }
            store.dispatch(setSingleCusInfo(res.data))
        })
        .catch((err)=>{
            store.dispatch(setSingleCusInfo(null))
        })
}